import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getPresentation(id) {
  // return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/presentation/get?id='+id);
      const session = await axios.get('/api/presentation/start?id='+id+ '&date=' + moment().format('MM-DD-YYYY h:mm a'));

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        return {
          presentation: data.payload,
          session: session.data.payload,
          token_proector: session.data.token_proector,
          token_student: session.data.token_student,
          token_teacher: session.data.token_teacher,
        };
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
   
      return Promise.reject({message: 'Bag request'})
      
    }
  // }
}


export async function getParams() {
  // return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/auth/params');
      if(data.errcode == 200) {
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})
    }
  // }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/PresentationsStart/actions.js